import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import LinePinsIndexPage from '../containers/LinePins'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const LinePinsPage = ({
  location,
	match
}) => {
  const dispatch = useDispatch()
	const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
	const { pathname } = location

	useEffect(() => {
		if (current[0] !== 'line_pins') {
			dispatch(changeCurrent(['line_pins']))
		}
	}, [pathname])

	const path = match.url

  return (
		<Switch>
			<Route path={`${path}/`} component={LinePinsIndexPage} exact />
		</Switch>
  )
}

LinePinsPage.propTypes = {
  location: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
}

LinePinsPage.defaultProps = {}

export default LinePinsPage
